exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".onScrollSocial a{color:#2b2b2b!important}", "", {"version":3,"sources":["/Users/telmo/Code/ahresp/taste-frontend/src/components/social/social.component.css"],"names":[],"mappings":"AAAA,kBACI,uBAAiC,CACpC","file":"social.component.css","sourcesContent":[".onScrollSocial a{ \n    color: hsl(0, 0%, 17%)!important;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"minimize":true,"sourceMap":true}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/social/social.component.css
// module id = 446
// module chunks = 0